/**
 * Which providers Forge installs, in the order they are shown.
 *
 * Its own module because both the provider surface and `useSettingsRestore`
 * read it, and the latter has nothing else to do with provider auth.
 *
 * @module
 */
import { ReactNode } from "react";

export type CliProviderSettings = {
  kind: "cli";
  provider: "codex" | "claudeAgent" | "cursor" | "opencode";
  title: string;
  binaryPlaceholder: string;
  binaryDescription: ReactNode;
  homePathKey?: "codexHomePath";
  homePlaceholder?: string;
  homeDescription?: ReactNode;
};

export type HttpProviderSettings = {
  kind: "http";
  provider: "apex";
  title: string;
  endpointPlaceholder: string;
  endpointDescription: ReactNode;
};

export type InstallProviderSettings = CliProviderSettings | HttpProviderSettings;

export const PROVIDER_SETTINGS: readonly InstallProviderSettings[] = [
  // Order: CMMD's first-party model endpoint leads, followed by the
  // third-party CLI providers in alphabetical-ish order. The backing setting
  // key is still `apex` for compatibility with existing persisted settings.
  {
    kind: "http",
    provider: "apex",
    title: "CMMD",
    endpointPlaceholder: "https://models.cmmd.ai",
    endpointDescription: "CMMD model endpoint URL.",
  },
  {
    kind: "cli",
    provider: "codex",
    title: "Codex",
    binaryPlaceholder: "Codex binary path",
    binaryDescription: "Path to the Codex binary",
    homePathKey: "codexHomePath",
    homePlaceholder: "CODEX_HOME",
    homeDescription: "Optional custom Codex home and config directory.",
  },
  {
    kind: "cli",
    provider: "claudeAgent",
    title: "Claude",
    binaryPlaceholder: "Claude binary path",
    binaryDescription: "Path to the Claude binary",
  },
  {
    kind: "cli",
    provider: "cursor",
    title: "Cursor",
    binaryPlaceholder: "cursor-agent binary path",
    binaryDescription: "Path to the Cursor Agent binary.",
  },
  {
    kind: "cli",
    provider: "opencode",
    title: "OpenCode",
    binaryPlaceholder: "opencode binary path",
    binaryDescription: "Path to the OpenCode binary.",
  },
];

export const PUBLIC_MVP_PROVIDER_SETTINGS = PROVIDER_SETTINGS;
